import { render } from "./UserHeader.vue?vue&type=template&id=5c2c3858"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"

import "./UserHeader.vue?vue&type=style&index=0&id=5c2c3858&lang=scss"

import exportComponent from "F:\\work\\angren\\qabul_auniver\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__